import React from 'react'

export const Legal: React.FC = () => (
  <div className="stk-text-align-c stk-space-in-t-3">
    <p className="stk-space-out-b-3">
      &copy; Stockopedia 2021, Refinitiv, Share Data Services.
    </p>

    <div className="stk-wrapper stk-wrapper--centered stk-space-out-b-3">
      {SOCIAL_LINKS.map((link, index) => (
        <React.Fragment key={index}>
          <a href={link.href} target="_blank" rel="noopener" key={index}>
            {link.label}
          </a>
        </React.Fragment>
      ))}
    </div>

    <p>
      This site cannot substitute for professional investment advice or
      independent factual verification. To use it, you must accept our&nbsp;
      {STOCKOPEDIA_LINKS.map((link, index) => (
        <React.Fragment key={index}>
          <a href={link.href} target="_blank" key={index}>
            {link.label}
          </a>
          {index + 2 === STOCKOPEDIA_LINKS.length ? (
            <>&nbsp;and</>
          ) : (
            <>{index + 1 !== STOCKOPEDIA_LINKS.length && <>,</>}</>
          )}
          &nbsp;
        </React.Fragment>
      ))}
      policies.
    </p>
  </div>
)

interface Link {
  label: string
  href: string
}

const SOCIAL_LINKS: ReadonlyArray<Link> = [
  { label: 'Facebook', href: 'https://www.facebook.com/stockopedia' },
  { label: 'Twitter', href: 'https://www.twitter.com/stockopedia' },
  { label: 'YouTube', href: 'https://www.youtube.com/user/Stockopedia' },
  { label: 'Instagram', href: 'https://www.instagram.com/stockopedia' },
  { label: 'RSS', href: '/feed/stockopedia_full.rss' },
]

const STOCKOPEDIA_LINKS: ReadonlyArray<Link> = [
  {
    label: 'Terms of Use',
    href: '/learn/account-billing/terms-of-use-463173/',
  },
  { label: 'Privacy', href: '/learn/account-billing/privacy-policy-463148' },
  { label: 'Disclaimer', href: '/learn/account-billing/disclaimer-463143/' },
]
